import { render, staticRenderFns } from "./FormUploadZodiac.vue?vue&type=template&id=4252c77c&scoped=true&"
import script from "./FormUploadZodiac.vue?vue&type=script&lang=js&"
export * from "./FormUploadZodiac.vue?vue&type=script&lang=js&"
import style0 from "./FormUploadZodiac.vue?vue&type=style&index=0&id=4252c77c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4252c77c",
  null
  
)

export default component.exports